/**************************************************
 * Nombre:       Formacion_Lidres
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import '@splidejs/react-splide/css';
import TarjetaTestimonios from "../../Tarjetas/TarjetaTestimonios";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import TextoTitulo from "./SucComponentes/TextoTitulo";
import TarjetaLidres from "../../Tarjetas/TarjetaLidres";

const Formacion_Lidres = ({item}) => {
    const {sCell} = useResponsive()


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >


                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 11}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <TextoTitulo texto={'Lideres'} titulo={'Lideres destacados que inspiran confianza'}/>
                    </Grid>

                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        {item && item.lideres && item.lideres.map((it, i) => (
                            <Grid key={'ds' + i} container size={{xs: 12, sm: 12, md: 3}}
                                  sx={{justifyContent: 'flex-start'}}>
                                <TarjetaLidres item={it}/>
                            </Grid>
                        ))}

                    </Grid>


                </Grid>


            </Grid>


        </Grid>
    )

}
export default Formacion_Lidres

